import axios from "axios";

export const NavSnipes = {
    ENDPOINT: 'https://navsnipesapi.maxgoddard.dev/',
    getEndpoint: (url) => NavSnipes.ENDPOINT + url,
    makeRequest: (method, url, data = {}, config = {}) => new Promise((resolve, reject) => {
        axios({
            method,
            url: NavSnipes.getEndpoint(url),
            data,
            headers: {
                ...(config.headers || {}),
                'Authorization': config.token ? `Bearer ${config.token}` : undefined,
            },
        }).then((res) => {
            const data = res.data;

            if (data.error) {
                reject(data);
            } else {
                resolve(data);
            }
        }).catch((err) => {
            reject({
                error: 'NETWORK_ERROR',
                message: 'Encountered a network error.',
                data: err,
            });
        });
    }),
    getLeaderboard: (order = '-k', perPage = 20, page = 0) =>
        NavSnipes.makeRequest(
            'get',
            `leaderboard/?order=${order}&per_page=${perPage}&page=${page}`,
        ),
    getKillfeed: (perPage = 20, page = 0) =>
        NavSnipes.makeRequest(
            'get',
            `killfeed/?per_page=${perPage}&page=${page}`,
        ),
};